const FONTS = {
  NAMES: 'PT Sans Narrow',
  BLOCKLETTER: 'Blockletter',
};

export default FONTS;
